export const MEDICAL_REPORT_SECTIONS = [
  ['patient_information', 'Patient Information'], ['vital_signs', 'vital_signs'],
  ['diagnosis', 'Diagnosis'], ['medications', 'Medications Items'], ['items', 'Service Items'],
  ['supporting_infos', 'supporting_infos'], ['accident_information', 'Accident Information'],
  ['immunization', 'immunization'], ['chief_complaints', 'chief_complaints'],
  ['family_history', 'family_history'], ['past_history', 'past_history'],
  ['physical_assessment', 'physical_assessment'], ['significant_signs', 'significant_signs'],
  ['other_conditions', 'other_condition'], ['progress_notes', 'progress_notes'],
  ['procedure_notes', 'procedure_notes'], ['nursing_notes', 'nursing_notes'],
  ['history_and_physical', 'history_and_physical'], ['consult_notes', 'consult_notes'],
  ['practitioner_signature', 'Practitioner Signature'], ['recommendations', 'Recommendations']
]

export const DEFAULT_MEDICAL_REPORT_SECTIONS = MEDICAL_REPORT_SECTIONS.map(([key]) => key)
